export default __webpack_public_path__ + "static/media/2.01abdc05.jpg";